import cloneDeep from 'clone-deep'
import { useEffect, useState } from 'react'
import { getInvestorServicers } from 'services/apis/conditions'
import { Modal } from 'stories/components'
import { InputConvert, InputValidate, removeComma } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { defaultInputs } from './constants'
import type { IInvestor } from './types'

interface InvestorServicer {
  id: number
  investorCode: string
  fullName: string
  type: number
}

export const AddInvestor = ({
  index,
  item,
  onClose,
  onUpdate,
}: {
  index: number
  item: IInvestor | null
  onClose: Function
  onUpdate: Function
}) => {
  const [loading, setLoading] = useState(false)
  const [inputs, setInputs] = useState(defaultInputs())
  const [investorServicers, setInvestorServicers] = useState<InvestorServicer[]>([])

  useEffect(() => {
    getInvestorServicers().then((data) => {
      setInvestorServicers(data)

      const optionsRecord: Record<string, string> = {}
      data.forEach((inv: InvestorServicer) => {
        optionsRecord[inv.id.toString()] = `${inv.investorCode} - ${inv.fullName}`
      })

      const newInputs = cloneDeep(defaultInputs())
      newInputs.lenderAccount.inputType = 'SearchableSelect'
      newInputs.lenderAccount.options = optionsRecord

      if (item) {
        Object.keys(newInputs).forEach((key) => {
          if ((item as any)[key] !== undefined) {
            newInputs[key].value = (item as any)[key]
          }
        })
      }

      setInputs(newInputs)
    })
  }, [item])

  const onChange = (key: string, value: string) => {
    let newInputs = cloneDeep(inputs)
    value = InputConvert(newInputs[key], value)
    newInputs[key].error = InputValidate({ ...newInputs[key], value })
    newInputs[key].value = value

    if (key === 'lenderAccount' && value) {
      const selectedInvestor = investorServicers.find((inv) => inv.id.toString() === value)
      if (selectedInvestor) {
        newInputs.lenderName.value = selectedInvestor.investorCode
      }
    }

    setInputs(newInputs)
  }

  const onSubmit = async () => {
    let hasError = false

    let newInputs = cloneDeep(inputs)
    const data: Record<string, any> = {}
    for (const key in inputs) {
      newInputs[key].error = InputValidate(newInputs[key])
      data[key] = newInputs[key].value
      if (newInputs[key].error) hasError = true
    }
    setInputs(newInputs)
    if (hasError) return

    data.pctOwned = removeComma(data.pctOwned)
    data.lenderRate = removeComma(data.lenderRate)
    data.principalBalance = removeComma(data.principalBalance)
    data.regularPayment = removeComma(data.regularPayment)

    setLoading(true)
    onUpdate(data)
  }

  return (
    <Modal
      title={item ? `Update Investor - No.${index + 1}` : 'Add Investor'}
      titleOkay="Submit"
      loading={loading}
      onClose={() => onClose()}
      onOk={onSubmit}
      childLevel={2}
      isOpen
    >
      <div className="text-gray-900">
        <div className="w-144 grid grid-cols-1 gap-3">
          {Object.keys(inputs).map((key, idx) => (
            <div key={idx}>
              <RenderInput input={inputs[key]} Key={key} onChange={onChange} />
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
